// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.verify label[data-v-1f746ca6] {\n    margin-left: 8px !important;\n}\n", ""]);
// Exports
module.exports = exports;
